
// 全部
const allServer = (resolve) => {
  import('components/server/server.all').then((module) => {
    resolve(module)
  })
}
// 登录服务器
const loginServer = (resolve) => {
  import('components/server/server.loginServer').then((module) => {
    resolve(module)
  })
}
// 网关服务器
const gatewayServer = (resolve) => {
  import('components/server/server.gatewayServer').then((module) => {
    resolve(module)
  })
}
// 用户服务器
const userServer = (resolve) => {
  import('components/server/server.userServer').then((module) => {
    resolve(module)
  })
}
// 流媒体服务器
const mediaServer = (resolve) => {
  import('components/server/server.mediaServer').then((module) => {
    resolve(module)
  })
}
// 存储服务器
const storageServer = (resolve) => {
  import('components/server/server.storageServer').then((module) => {
    resolve(module)
  })
}
// 下载站点
const downloadStation = (resolve) => {
  import('components/server/server.downloadStation').then((module) => {
    resolve(module)
  })
}
// 下载服务器
const downloadServer = (resolve) => {
  import('components/server/server.downloadServer').then((module) => {
    resolve(module)
  })
}
// 用户日志
const userLog = (resolve) => {
  import('components/server/server.userLog').then((module) => {
    resolve(module)
  })
}
// 平台运行监控
const platformOperationMonitor = (resolve) => {
  import('components/server/server.platformOperationMonitor').then((module) => {
    resolve(module)
  })
}
// 出租车网关服务器
const taxiGatewayServer = (resolve) => {
  import('components/server/server.taxiGatewayServer').then((module) => {
    resolve(module)
  })
}
// 部标网关服务器
const BBGatewayServer = (resolve) => {
  import('components/server/server.BBGatewayServer').then((module) => {
    resolve(module)
  })
}
// 部标存储服务器
const BBstorageServer = (resolve) => {
  import('components/server/server.BBstorageServer').then((module) => {
    resolve(module)
  })
}
// websocket服务器
const websocketServer = (resolve) => {
  import('components/server/server.websocketServer').then((module) => {
    resolve(module)
  })
}
// web服务器
const webServer = (resolve) => {
  import('components/server/server.webServer').then((module) => {
    resolve(module)
  })
}

// 地址解析服务器
const addressResolutionServer = (resolve) => {
  import('components/server/server.addressResolutionServer').then((module) => {
    resolve(module)
  })
}

// 地址服务器设置
const addressConfigurationServer = (resolve) => {
  import('components/server/server.addressConfigurationServer').then((module) => {
    resolve(module)
  })
}

// SNMP
const SNMP = (resolve) => {
  import('components/server/server.SNMP').then((module) => {
    resolve(module)
  })
}
// FTP管理
const ftpManage = (resolve) => {
  import('components/server/server.ftpManage').then((module) => {
    resolve(module)
  })
}
const serverRouter = {
  serverPath: [
    {
      path: '/server/allServer', // 全部
      component: allServer
    },
    {
      path: '/server/loginServer', // 登录服务器
      component: loginServer
    },
    {
      path: '/server/gatewayServer', // 网关服务器
      component: gatewayServer
    },
    {
      path: '/server/userServer', // 用户服务器
      component: userServer
    },
    {
      path: '/server/mediaServer', // 流媒体服务器
      component: mediaServer
    },
    {
      path: '/server/storageServer', // 存储服务器
      component: storageServer
    },
    {
      path: '/server/downloadStation', // 下载站点
      component: downloadStation
    },
    {
      path: '/server/downloadServer', // 下载服务器
      component: downloadServer
    },
    {
      path: '/server/userLog', // 用户日志
      component: userLog
    },
    {
      path: '/server/platformOperationMonitor', // 平台运行监控
      component: platformOperationMonitor
    },
    {
      path: '/server/taxiGatewayServer', // 出租车网关服务器
      component: taxiGatewayServer
    },
    {
      path: '/server/BBGatewayServer', // 部标网关服务器
      component: BBGatewayServer
    },
    {
      path: '/server/BBstorageServer', // 部标存储服务器
      component: BBstorageServer
    },
    {
      path: '/server/websocketServer', // websocket服务器
      component: websocketServer
    },
    {
      path: '/server/webServer', // web服务器
      component: webServer
    },
    {
      path: '/server/addressResolutionServer', // websocket服务器
      component: addressResolutionServer
    },
    {
      path: '/server/addressConfigurationServer', // 地址服务器设置
      component: addressConfigurationServer
    },
    {
      path: '/server/ftpManage', // FTP管理
      component: ftpManage
    },
    {
      path: '/server/SNMP', // SNMP
      component: SNMP
    }
  ]
}

export default serverRouter



// WEBPACK FOOTER //
// ./src/router/server.js